export default "__VITE_ASSET__zhRstPxU__"